module.exports = __webpack_public_path__ + "assets/img/star_sentence_un_select10.ede6e967.png";